import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import "react-dropdown/style.css";
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import './index.css'
import './sass/main.css';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './appStore/store';
import Routes from './routes';
import { Box } from '@material-ui/core';
import SpinnerLoader from './components/common/spinner';

// import BrandedFareContainer from './pages/flights/brandedFare/BrandedFareContainer';

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Box id="headerLoader" className="header-loader">
      <SpinnerLoader />
    </Box>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </PersistGate>
    <Box id="footerLoader" className="footer-loader">
      <SpinnerLoader />
    </Box>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
